// Port of api/fuel/app/classes/controller/api/monty/app/devlog.php
import Constants from 'offline/constants'
import DB from 'offline/db'
import Util from 'offline/util'

function toArray(row) {
	return {
		id: parseInt(row.devlog_id, 10),
		type: parseInt(row.devlog_type, 10),
		date: parseInt(row.devlog_date, 10),
		name: row.devlog_name,
		content: row.devlog_content,
		url: row.devlog_url,
		image: row.devlog_image,
		count: {
			features: parseInt(row.devlog_count_features || 0, 10),
			fixes: parseInt(row.devlog_count_fixes || 0, 10)
		}
	}
}

export default function(params) {
	var now = Util.time()

	if (params.slug) {
		var rows = []

		if (params.slug === 'latest') {
			rows = DB.query('SELECT * FROM devlog WHERE devlog_date < ? ORDER BY devlog_date DESC LIMIT 1', [now])
		} else {
			rows = DB.query('SELECT * FROM devlog WHERE devlog_slug = ? AND devlog_date < ? ORDER BY devlog_date DESC LIMIT 1', [params.slug, now])
		}

		if (!rows.length) {
			return Promise.reject({ error: Constants.API_ERROR_INVALID, offline: true })
		}

		return Promise.resolve({
			post: toArray(rows[0])
		})
	}

	var devlog = DB.query('SELECT * FROM devlog WHERE devlog_date < ? ORDER BY devlog_date DESC LIMIT 100', [now]).map(toArray)

	return Promise.resolve({
		devlog: devlog
	})
}
